import script from "./cpt-phone-option.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-phone-option.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__